export default __webpack_public_path__ + "static/media/product-image-19.370ff8b2.jpg";